export default {
  fromServer: data => data.map(value => ({ id: value, name: value }))
};
